import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

export const Name = styled(TextElementNova)`
  padding-top: 16px;
  @media (min-width: 768px) and (max-width: 1023px) {
    padding-top: 24px;
  }
`

export const Quote = styled(TextElementNova)`
  @media (min-width: 1024px) and (max-width: 1440px) {
    font-size: 22px !important;
  }
`

export const ProductText = styled(TextElementNova)`
  a {
    color: #007a73 !important;
  }
`

export const TagsContainer = styled(Flex)`
  gap: 8px;
  flex-wrap: wrap;
`

export const Tag = styled(TextElementNova)`
  padding: 5px 10px 4px;
  border-radius: 4px;
  white-space: nowrap;

  &:last-of-type {
    margin-right: 0;
  }
`
